export const SOP_CONTENT = [
    {
        title: "📋 Core SOP",
        coreConcepts: [
          { title: "Clock In/Out Procedures", detailKey: "clockInOut" },
          { title: "Opening Procedures", detailKey: "openingProcedures" },
          { title: "Closing Procedures", detailKey: "closingProcedures" },
          { title: "Emergency Protocols", detailKey: "emergencyProtocols" },
          { title: "Incident Reporting", detailKey: "incidentReporting" },
          { title: "Sanitation Standards", detailKey: "sanitationStandards" },
          { title: "Communication Protocol", detailKey: "communicationProtocol" },
          { title: "Client Interaction SOP", detailKey: "clientInteraction" },
          { title: "Uniform & Hygiene Standards", detailKey: "uniformStandards" },
          { title: "Pet ID & Transport Safety", detailKey: "petIdSafety" }
        ]
      },
      {
        title: "🛒 Front Desk SOP",
        coreConcepts: [
          { title: "Welcome Desk Etiquette & First Impressions", detailKey: "frontDeskEtiquette" },
          { title: "Paw Parent App Walkthrough & FAQ", detailKey: "parentAppSupport" },
          { title: "New Client Intake Overview", detailKey: "newClientIntakeFD" },
          { title: "Check-In/Out Process", detailKey: "checkInOutProcess" },
          { title: "Tour SOP", detailKey: "tourProtocol" },
          { title: "Phone Call SOP", detailKey: "phoneCallSOP" },
          { title: "Client Booking Management & Calendar Updates", detailKey: "bookingCalendar" },
          { title: "Service Add-On Reminders & Upsell Flow", detailKey: "upsellReminders" },
          { title: "Multi-Service Coordination Across Departments", detailKey: "departmentCoordination" },
          { title: "Late Pickup & Cancellation Policy Enforcement", detailKey: "policyEnforcement" },
          { title: "Payment Collection & Refund Protocol", detailKey: "paymentRefundProtocol" },
          { title: "Email, Text & Chat Communication Standards", detailKey: "writtenCommunicationFD" },
          { title: "Incident Intake & Escalation to Manager", detailKey: "incidentEscalationFrontDesk" },
          { title: "Retail & Inventory", detailKey: "retailInventory" },
          { title: "Lost & Found Protocol", detailKey: "lostFound" }
        ]
      },   
      {
        title: "🛁 Grooming SOP",
        coreConcepts: [
          { title: "Pre-Groom Health & Coat Check", detailKey: "preGroomInspection" },
          { title: "Photo/Video Documentation for Grooming Guests", detailKey: "groomingPhotoSnapshots" },
          { title: "Client Alerts & Special Notes", detailKey: "groomingClientAlerts" },
          { title: "Bathing Protocols & Coat Prep", detailKey: "bathingProtocols" },
          { title: "Matting Policy & Procedure", detailKey: "mattingPolicyProcedure"},        
          { title: "Nail Trimming & Paw Care", detailKey: "nailTrimming" },
          { title: "Haircut Flow & Styling Steps", detailKey: "groomingSteps" },
          { title: "Handling Anxious or Reactive Pets", detailKey: "handlingDifficultPets" },
          { title: "Product Usage & Allergy Awareness", detailKey: "groomingProductUsage" },
          { title: "Time Standards & Workflow Tips", detailKey: "groomingTimeStandards" },
          { title: "Tool Care & Station Cleanliness", detailKey: "toolCareStationCleanliness" },
          { title: "Groomer Safety & Ergonomic Practice", detailKey: "groomerSafety" },
          { title: "Post-Groom Handoff & Client Notes", detailKey: "postGroomHandoff" }
        ]
      },      
      {
        title: "🧸 Daycare SOP",
        coreConcepts: [
          { title: "Morning Check-In Routine", detailKey: "daycareCheckIn" },
          { title: "New Client Trial & Temperament Test", detailKey: "trialTemperamentTest" },
          { title: "Playgroup Influencers & Canine Role Models", detailKey: "playgroupInfluencers" },
          { title: "Positive Reinforcement & Redirection Techniques", detailKey: "positiveRedirection" },
          { title: "Playgroup Sorting & Safety", detailKey: "playgroupSorting" },
          { title: "Group Management During Play", detailKey: "groupManagement" },
          { title: "Play Style Identification & Tracking", detailKey: "playStyleTracking" },
          { title: "Enrichment Program & Philosophy", detailKey: "enrichmentBlock" },
          { title: "Puppy-Specific Protocols", detailKey: "puppyProtocol" },
          { title: "Senior Pet Care", detailKey: "seniorPetCare" },
          { title: "Feeding & Medication Protocols", detailKey: "feedingMedication" },
          { title: "Behavioral Incident", detailKey: "behaviorIncident" },
          { title: "Quiet Time Setup & Supervision", detailKey: "quietTimeSetup" },
          { title: "Client Alert System", detailKey: "clientAlertSystem" },
          { title: "Photo Snapshots for Daycare Guests", detailKey: "daycarePhotoSnapshots" },
          { title: "Daily Report Cards & Parent Communication", detailKey: "dailyReportCards" },
          { title: "End-of-Day Check-Out Routine", detailKey: "daycareCheckout" },
          { title: "Sanitation & Cleaning Protocols", detailKey: "daycareCleaning" },
        ]
      },      
      {
        title: "🏨 Boarding SOP",
        coreConcepts: [
          { title: "Boarding Intake & Parent Communication", detailKey: "boardingIntake" },
          { title: "Meal & Medication Logs", detailKey: "mealMedicationLogs" },
          { title: "Crate Comfort Checks & Setup", detailKey: "crateComfortChecks" },
          { title: "Boarding Dashboard Check-Ins & Updates", detailKey: "boardingDashboardUpdates" },
          { title: "Calming Techniques & Handling Reactive Dogs", detailKey: "boardingCalmingReactiveDogs" },
          { title: "Routine Walks & Potty Schedule", detailKey: "routineWalksPotty" },
          { title: "Addon Services During Boarding Stay", detailKey: "boardingAddonServices" },
          { title: "Photo Snapshots for Boarding Guests", detailKey: "boardingPhotoSnapshots" },
          { title: "Departure Status Update", detailKey: "departureStatusAppUpdate" }
        ]
      },      
      {
        title: "🐕 Training SOP",
        coreConcepts: [
          { title: "Training Philosophy & Approved Tools", detailKey: "trainingPhilosophyTools" },
          { title: "Handler Energy & Body Language", detailKey: "handlerEnergy" },
          { title: "Intake & Client Communication", detailKey: "trainingClientIntake" },
          { title: "Training Session & Space Setup", detailKey: "trainingSessionAndSpacePrep" },
          { title: "Private Session SOP", detailKey: "privateSessionSOP" },
          { title: "Group Class SOP", detailKey: "groupClassSOP" },
          { title: "Puppy Class SOP", detailKey: "puppyClassSOP" },
          { title: "Progress Tracking & Homework Notes", detailKey: "trainingProgressTracking" },
          { title: "Behavior Issue Escalation Protocol", detailKey: "behaviorEscalation" },
          { title: "Client Training Materials Distribution", detailKey: "clientTrainingMaterials" },
          { title: "Follow-Up Expectations", detailKey: "trainingFollowUp" }
        ]
      },      
      {
        title: "🚌 Shuttle SOP",
        coreConcepts: [
          { title: "Vehicle Cleanliness", detailKey: "vehicleCleanliness" },
          { title: "Pre-Departure Safety Checklist", detailKey: "preDepartureChecklist" },
          { title: "Pickup & Drop-Off Timing SOP", detailKey: "pickupDropoffTiming" },
          { title: "No-Show or Delay Protocol", detailKey: "noShowDelayProtocol" },
          { title: "Dog Loading & Crate Safety Procedures", detailKey: "crateLoadingSafety" },
          { title: "Route Optimization & Communication", detailKey: "routeCommunication" },
          { title: "Client Interaction Etiquette (At the Door)", detailKey: "shuttleClientEtiquette" },
          { title: "Behavioral Incident Handling During Transport", detailKey: "transportIncidentProtocol" },
          { title: "End-of-Day Shuttle Recap & Reporting", detailKey: "shuttleEndOfDayRecap" }
        ]
      },         
      {
        title: "📂 Manager SOP",
        coreConcepts: [
          { title: "Staff Onboarding & Orientation", detailKey: "managerOnboarding" },
          { title: "Shadowing & Training Pathways", detailKey: "managerShadowingTraining" },
          { title: "Performance Reviews & Feedback Cycles", detailKey: "performanceReviews" },
          { title: "Conflict Resolution & Staff Mediation", detailKey: "conflictResolution" },
          { title: "Interdepartmental Communication Flow", detailKey: "interdepartmentalFlow" },
          { title: "Daily Task Board Review & Shift Oversight", detailKey: "dailyTaskOversight" },
          { title: "Client Complaint Response & Recovery", detailKey: "clientRecovery" },
          { title: "Incident Follow-Up & Documentation", detailKey: "incidentFollowUp" },
          { title: "Schedule Adjustments & Coverage", detailKey: "scheduleAdjustments" },
          { title: "Supplies Ordering & Vendor Coordination", detailKey: "suppliesVendorCoordination" },
          { title: "Facilities Escalation & Maintenance Requests", detailKey: "managerFacilities" },
          { title: "End-of-Day Walkthrough & Lock-Up", detailKey: "managerClosingChecklist" },
          { title: "New Program or Policy Rollout Protocol", detailKey: "policyRollout" },
          { title: "Trainee to Lead Promotion Criteria", detailKey: "staffPromotionCriteria" },
          { title: "Emergency Leadership Response Protocol", detailKey: "managerEmergencyResponse" }
        ]
      },      
      // {
      //   title: "📸 Marketing & Content SOP",
      //   coreConcepts: [
      //     { title: "Capturing Shareable Moments", detailKey: "capturingContent" },
      //     { title: "Client Consent & Pet Safety", detailKey: "contentConsentSafety" },
      //     { title: "Posting Standards & Brand Voice", detailKey: "postingStandards" },
      //     { title: "Content Calendar & Collaboration", detailKey: "contentCalendar" }
      //   ]
      // },
      // {
      //   title: "🧰 Facilities & Maintenance SOP",
      //   coreConcepts: [
      //     { title: "Daily Walkthrough & Maintenance Log", detailKey: "dailyFacilityCheck" },
      //     { title: "Urgent Repairs & Safety Hazards", detailKey: "urgentRepairProtocol" },
      //     { title: "Vendor Coordination & Restocking", detailKey: "vendorCoordination" },
      //     { title: "Equipment Sanitation Checklist", detailKey: "equipmentSanitation" }
      //   ]
      // },
      // {
      //   title: "🎉 Events & Outreach SOP",
      //   coreConcepts: [
      //     { title: "Planning & Scheduling", detailKey: "eventPlanning" },
      //     { title: "Setup, Staff Roles & Run-of-Show", detailKey: "eventExecution" },
      //     { title: "Photo & Feedback Collection", detailKey: "eventMediaFeedback" },
      //     { title: "Post-Event Summary & Debrief", detailKey: "eventDebrief" }
      //   ]
      // },
];